import environment from '@utilities/environment';

export const getPrefixedUrl = (path: string) => {
    let prefix: string = '';

    if (environment.isLocal) prefix = window.__ENVIRONMENT_DETAILS__.baseApi;

    return prefix + path;
};
